"use strict";const e=require("../createBrandTheme.js"),t=e.createBrandTheme({main:"#FF69B4",light:"#FF99CC",dark:"#CC5490",contrastText:"#FFFFFF"});module.exports=t;
//# sourceMappingURL=index.js.map
